/** One invoice carries one rate (PNTS-3229). The value is the percentage, except for reverse charge. */
export enum OutgoingInvoiceVatRates {
  HIGH = 21,
  LOW = 9,
  ZERO = 0,
  REVERSE_CHARGE = -1
}

export const OUTGOING_INVOICE_VAT_RATE_OPTIONS: { key: OutgoingInvoiceVatRates; label: string }[] =
  [
    { key: OutgoingInvoiceVatRates.HIGH, label: "21% btw" },
    { key: OutgoingInvoiceVatRates.LOW, label: "9% btw" },
    { key: OutgoingInvoiceVatRates.ZERO, label: "0% btw" },
    { key: OutgoingInvoiceVatRates.REVERSE_CHARGE, label: "Btw verlegd" }
  ]

export function outgoingInvoiceVatRateLabel(rate: OutgoingInvoiceVatRates | number): string {
  return (
    OUTGOING_INVOICE_VAT_RATE_OPTIONS.find((option) => option.key === rate)?.label ?? `${rate}%`
  )
}
